import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

import { media } from "../styles"

/*
  Why does this exist, you ask? Because reusable components should not be
  managing outer margins, since they will be different in different contexts.
  See also "Margin Considered Harmful": https://mxstbr.com/thoughts/margin
`*/

const SpacerEl = styled.div`
  height: 1px;

  ${(props) => {
    return css`
      ${
        // check for undefined specifically as 0 is falsey
        props.$height !== undefined &&
        `
        margin-bottom: ${props.$height - 1}px;
      `
      }

      ${props.$sm !== undefined &&
      `
      @media ${media.sm} {
        margin-bottom: ${props.$sm - 1}px;
      }
      `}

    ${props.$md !== undefined &&
      `
      @media ${media.md} {
        margin-bottom: ${props.$md - 1}px;
      }
    `}

    ${props.$lg !== undefined &&
      `
      @media ${media.lg} {
        margin-bottom: ${props.$lg - 1}px;
      }
    `}

    ${props.$xl !== undefined &&
      `
      @media ${media.xl} {
        margin-bottom: ${props.$xl - 1}px;
      }
    `}

    ${props.$xxl !== undefined &&
      `
      @media ${media.xxl} {
        margin-bottom: ${props.$xxl - 1}px;
      }
    `}

    ${props.$print !== undefined &&
      `
      @media print {
        margin-bottom: ${props.$print - 1}px;
      }
    `}
    `
  }};
`

const Spacer = ({ height, sm, md, lg, xl, xxl, print }) => {
  return (
    <SpacerEl
      aria-hidden="true"
      $height={height}
      $sm={sm}
      $md={md}
      $lg={lg}
      $xl={xl}
      $xxl={xxl}
      $print={print}
    />
  )
}

Spacer.propTypes = {
  height: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
  xxl: PropTypes.number,
  print: PropTypes.number,
}

export default Spacer
